import Vue from 'vue'
import store from '../store/index'
import {Button} from 'element-ui';

//导出Excel按钮
Vue.component('buttonExcel',{
  template:'<el-button type="primary" plain><i class="el-icon-download"></i> 导出Excel</el-button>'
});
//强制开关
Vue.component('buttonSwitch',{
  template:' <el-button type="warning"><i class="iconfont icon-deng-gray" style="margin-right: 5px"></i>强制开关</el-button>'
});
//搜索按钮
Vue.component('buttonSearch',{
  template:'<el-button type="primary"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>'
});
// 区块标题加图标
Vue.component('iconText',{
  props: ['attributes'],
  template:'<div style="display: flex;height: 24px;">' +
    '<div style="height: 18px; margin-top: 2px;" :style="{borderRightColor:this.attributes[0],borderRightWidth:5+`px`,borderRightStyle:`solid`,marginRight:10+`px`,borderRadius:10+`px`}">' +
    '</div><div style="line-height: 24px;height:24px;font-weight: bold">{{this.attributes[1]}}</div></div>',
});
// 标签 slot 是需要额外显示得内容
Vue.component('baseTags',{
  props: ['text', 'color'],
  template: `
    <transition name="el-zoom-in-center" class="tags_transition">
      <div class="tags_wrapper">
        <div class="tags_wrap" :style="{color: color, borderColor: color}"
          style="display: inline-block;height: 28px; line-height: 28px;font-size: 14px;font-weight: 500;padding: 0 6px;
          border-width: 1px;border-style: solid;border-radius: 4px;">
          <i class="tags_text" style="font-style: normal;">{{text}}</i>
        </div>
        <slot></slot>
      </div>
    </transition>
  `,
  mounted() {},
  beforeDestroy() {}
});



// WEBPACK FOOTER //
// ./src/commonComponents/common.js